import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../services/usuarios.service';
import { ActivatedRoute } from '@angular/router';
import { UsernomalDTO } from '../model/UsernomalDTO';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-edit-profile',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {
  profile: UsernomalDTO = {
    id: '',
    username: '',
    email: '',
    nacionalidad: '',
    role: '',
    facebook: '',
    twitter: '',
    instagram: '',
    imgPerfil: '',
    imgBanner: ''
  };

  errorMessage: string = '';

  constructor(
    private usuariosService: UsuariosService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const userId = this.route.snapshot.paramMap.get('id');
    if (userId) {
      this.fetchUserDetails(userId);
    } else {
      this.errorMessage = 'No se encontró el ID del usuario.';
    }
  }

  fetchUserDetails(userId: string): void {
    this.usuariosService.getUserById(userId).subscribe({
      next: (data: UsernomalDTO) => {
        this.profile = data; // Actualiza el perfil con los datos obtenidos
      },
      error: (error: any) => {
        this.errorMessage = 'Error al obtener los datos del usuario.';
        console.error(error);
      }
    });
  }

  // Cambiar la imagen de perfil
  onProfileImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.profile.imgPerfil = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  // Cambiar la imagen del banner
  onBannerImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.profile.imgBanner = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  // Guardar cambios
  onSubmit(): void {
    this.usuariosService.updateUser(this.profile.id, this.profile).subscribe({
      next: (updatedProfile: UsernomalDTO) => {
        console.log('Perfil actualizado:', updatedProfile);
        alert('Perfil actualizado correctamente.');
      },
      error: (error: any) => {
        this.errorMessage = 'Error al actualizar el perfil.';
        console.error(error);
      }
    });
  }
}